import { Component } from '@angular/core';

import { DashboardStore } from '../dashboardv2.store';
import { ERROR_CONTAINER_ID } from '../error-icon/error-icon.component';

@Component({
  selector: 'app-dashboard-revenue',
  standalone: false,
  templateUrl: './dashboard-revenue.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
    './dashboard-revenue.component.scss',
  ],
})
export class DashboardRevenueComponent {

  header$ = this.dashboardStore.sharedViewModel$;

  events$ = this.dashboardStore.eventsViewModel$;

  averageInvoiceSize$ = this.dashboardStore.averageInvoiceSizeViewModel$;

  averageJobSize$ = this.dashboardStore.averageJobSizeViewModel$;

  averageBookingSize$ = this.dashboardStore.averageBookingSizeViewModel$;

  averageScheduledJobSize$ = this.dashboardStore.averageScheduledJobSizeViewModel$;

  errorContainerId = ERROR_CONTAINER_ID;

  constructor(
    private readonly dashboardStore: DashboardStore,
  ) {}

}
